<template>
  <div class="report-warp">
    <div class="report-content">
      <div class="report-container">
        <h1 class="question-title">智能公共法律服务报告</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { createReport } from '@/api/api'
export default {
  name: 'report',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .report-warp {
    background-image: url(../../static/img/bg.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 100vh;
    position: relative;
    color: #333;
    .report-content {
      background: #fff;
      width: 50vw;
      height: 85vh;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      vertical-align: middle;
      padding: 15px 0;
      background-image: url(../../static/img/questionbg.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: bottom;
      .report-container {
        position: relative;
        height: 100%;
        overflow-y: auto;
        padding: 0 15px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/Report.vue